const CONSTANTS = {
    // switches
    ON_SWITCH_LIST_IS_LOADING: 'homes/ON_SWITCH_LIST_IS_LOADING',
    ON_SWITCH_LIST: 'homes/ON_SWITCH_LIST',
    ON_RELAY_TYPES_IS_LOADING: 'homes/ON_RELAY_TYPES_IS_LOADING',
    ON_RELAY_TYPES: 'homes/ON_RELAY_TYPES',
    ON_SELECT_SWITCH: 'homes/ON_SELECT_SWITCH',
    ON_EDIT_RELAY: 'switch/ON_EDIT_RELAY',
    ON_PATCH_RELAY: 'switch/ON_PATCH_RELAY',
    ON_SAVE_SWITCH: 'switch/ON_SAVE_SWITCH',
    ON_EDIT_SWITCH: 'switch/ON_EDIT_SWITCH',
    ON_PATCH_SWITCH: 'switch/ON_PATCH_SWITCH',
    ON_DELETE_SWITCH: 'switch/ON_DELETE_SWITCH',
    ON_DELETED_SWITCH: 'switch/ON_DELETED_SWITCH',
};

export { CONSTANTS };
